import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  milestoneContainer: {
    padding: '0px 24px 0px 0px !important',
    width: '100%',
    [theme.breakpoints.down('ultraHD')]: {
      padding: '0px 18px 0px 0px !important',
    },
  },
  title: {
    fontSize: '14px',
    marginBottom: '2px',
    fontWeight: 600,
    color: 'black',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },

  titles: {
    fontSize: '16px',
    fontName: 'General Sans',
    color: '#8A8A8A',
    fontWeight: '500 !important',
    alignItems: 'flex-start',
    marginBottom: '12px !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px',
      marginBottom: '9px !important',
    },
  },
  milestoneTitle: {
    fontSize: '16px',
    fontName: 'General Sans',
    color: 'black',
    fontWeight: '500 !important',
    alignItems: 'flex-start',
    textAlign: 'left',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px',
    },
  },
  function: {
    fontSize: '14px',
  },
  mileStoneBox: {
    display: 'flex',
    flexDirection: 'column',
    wordWrap: 'break-word',
    alignItems: 'flex-start',
    maxWidth: '130px',
    padding: '-6px',
    gap: '5px',
    [theme.breakpoints.down('ultraHD')]: {
      gap: '3.75px',
    },
  },
  avatarBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  expandIcon: {
    backgroundColor: '#F0EDF6',
    border: '1px solid #D1C8E3',
    width: '36px',
    height: '36px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '4px',
    [theme.breakpoints.down('ultraHD')]: {
      border: '0.75px solid #D1C8E3',
      borderRadius: '3px',
      width: '27px',
      height: '27px',
    },
  },
  verticalLine: {
    borderLeft: '1px solid black',
    height: '500px',
  },
  description: {
    fontSize: '14px',
    marginBottom: '2%',
    fontWeight: 400,
    color: 'black',
    textAlign: 'left',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  dateRange: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#99a3a4',
    textAlign: 'left',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '10.5px',
    },
  },
  linkedToText: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#8A8A8A',
    textAlign: 'left',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '10.5px',
    },
  },
  linkedPersonName: {
    fontSize: '16px',
    fontWeight: 500,
    color: '#545454',
    textAlign: 'left',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px',
    },
  },
  updatedDate: {
    fontSize: '14px',
    fontWeight: 400,
    color: '#99a3a4',
    textAlign: 'right',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '10.5px',
    },
  },
  avatar: {
    height: '36px',
    width: '36px',
    fontSize: '14px !important',
    color: '#6A4EA6 !important',
    backgroundColor: '#F0EDF6 !important',
    [theme.breakpoints.down('ultraHD')]: {
      height: '27px',
      width: '27px',
      fontSize: '12px !important',
    },
  },
  status: {
    borderRadius: '100px',
    padding: '6px 18px',
    fontSize: '14px',
    fontWeight: '500 !important',
    [theme.breakpoints.down('ultraHD')]: {
      borderRadius: '75px',
      padding: '4.5px 14px',
      fontSize: '10.5px',
    },
  },

  BoxContainer: {
    background: '#FFF !important',
    height: '87.5vh',
    margin: '24px',
    borderRadius: '12px',
    overflow: 'auto',
    flexWrap: 'wrap',
    [theme.breakpoints.down('ultraHD')]: {
      margin: '18px',
      height: '88vh',
      borderRadius: '9px',
    },
    [theme.breakpoints.down('fullHD')]: {
      height: '88vh',
    },
    [theme.breakpoints.down('HD')]: { height: '87vh' },
    [theme.breakpoints.down('xxl')]: {
      height: '87vh',
    },
    [theme.breakpoints.down('xl')]: {
      height: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '0px',
      height: '100vh',
      borderRadius: '0px',
      background: 'transparent !important',
    },
  },
  filterBtn: {
    background: `${theme.palette.KenColors.kenWhite} !important`,
    color: `${theme.palette.KenColors.ClientBlack2} !important`,
    boxShadow: 'none !important',
    fontSize: '16px !important',
    height: '48px',
    padding: '8px 24px !important',
    borderRadius: '8px !important',
    fontWeight: '500 !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px !important',
      height: '36px',
      padding: '4px 18px !important',
      borderRadius: '6px !important',
    },
  },
  addMilestoneBtn: {
    background: `#F0EDF6 !important`,
    color: `#604797 !important`,
    boxShadow: 'none !important',
    fontSize: '16px !important',
    height: '48px',
    padding: '8px 24px !important',
    borderRadius: '8px !important',
    fontWeight: '500 !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px !important',
      height: '36px',
      padding: '4px 18px !important',
      borderRadius: '6px !important',
    },
  },
  BoxSubContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '24px',
    flexWrap: 'wrap',
    [theme.breakpoints.down('ultraHD')]: {
      padding: '18px',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0px',
      display: 'none',
    },
  },
  mainContent: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    padding: '24px',
    [theme.breakpoints.down('ultraHD')]: {
      padding: '18px',
    },
  },
  milestonebar: {
    display: 'flex',
    backgroundColor: `#F0EDF6 !important`,
    border: '1px solid #FFF',
    borderRadius: '12px',
    flexDirection: 'column',
    flexWrap: 'wrap',
    color: 'white',
    padding: '12px !important',
    [theme.breakpoints.down('ultraHD')]: {
      padding: '9px !important',
      borderRadius: '9px',
      border: '0.75px solid #FFF',
    },
  },
  leftPanel: {
    display: 'flex',
    flexDirection: 'column',
  },
  leftPanelHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
  },
  milestoneTitleContainer: {
    display: 'flex',
    alignItems: 'left',
    flexDirection: 'column',
    gap: '9px',
    marginTop: '11px !important',
    [theme.breakpoints.down('ultraHD')]: {
      marginTop: '8px !important',
    },
  },
  milestoneIdContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  milestoneId: {
    display: 'flex',
    fontSize: '14px !important',
    color: 'black',
    alignItems: 'left',
    fontWeight: '500 !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '10.5px !important',
    },
  },
  filterIcon: {
    fontSize: '18px',
    color: '#666',
  },
  statusText: {
    display: 'flex',
    alignItems: 'left',
    fontSize: '12px',
    marginLeft: '8px',
    marginBottom: '8px',
  },
  MilestoneTitle: {
    display: 'flex',
    alignItems: 'left',
    color: '#333 !important',
    fontSize: '16px !important',
    fontWeight: '500 !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px !important',
    },
  },
  goalCard: {
    display: 'flex',
    justifyContent: 'space-between',
    border: '1px solid #E0E0E0',
    borderRadius: '8px',
    padding: '12px',
    marginBottom: '16px',
    cursor: 'pointer',
    '&:last-child': {
      marginBottom: 0,
    },
    [theme.breakpoints.down('ultraHD')]: {
      padding: '8px',
    },
  },
  goalCardContainer: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left',
    justifyContent: 'flex-start',
    flex: 1,
  },
  goalCardStatusContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '10px',
    [theme.breakpoints.down('ultraHD')]: {
      marginTop: '8.5px',
    },
  },
  activeGoalCard: {
    backgroundColor: '#F5F5F5',
    borderColor: '#5E35B1',
  },
  inactiveGoalCard: {
    backgroundColor: '#FFFFFF',
  },
  goalId: {
    fontSize: '14px !important',
    marginBottom: '8px',
    fontWeight: '500 !important',
    color: '#332620 !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '10.5px !important',
    },
  },
  activeGoalId: {
    color: '#5E35B1',
  },
  inactiveGoalId: {
    color: '#666',
  },
  goalTitle: {
    fontSize: '16px !important',
    marginBottom: '8px',
    color: '#2D2146 !important',
    fontWeight: '500 !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px !important',
    },
  },
  goalStatus: {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px !important',
    },
  },
  rightPanel: {
    flexWrap: 'wrap',
  },
  MileStoneBox: {
    border: '1px solid #E0E0E0',
    borderRadius: '8px',
    padding: '24px !important',
    flexWrap: 'wrap',
    boxShadow: '0px 1px 40px rgba(0, 0, 0, 0.05)',
    [theme.breakpoints.down('ultraHD')]: {
      padding: '18px !important',
      boxShadow: '0px 0.75px 30px rgba(0, 0, 0, 0.05)',
      border: '0.75px solid #E0E0E0',
    },
  },
  rightPanelHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
    marginBottom: '24px !important',
    borderBottom: '1px solid #D1C8E3',
    [theme.breakpoints.down('ultraHD')]: {
      marginBottom: '18px !important',
      borderBottom: '0.75px solid #D1C8E3',
    },
  },
  rightPanelTitle: {
    fontSize: '20px !important',
    fontWeight: '600 !important',
    color: '#333333',
    paddingBottom: '12px !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '15px !important',
      paddingBottom: '9px !important',
    },
  },
  rightPanelTitle2: {
    fontSize: '20px !important',
    fontWeight: '500 !important',
    color: '#545454',
    paddingBottom: '12px !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '15px !important',
      paddingBottom: '9px !important',
    },
  },
  moreButton: {
    color: '#666',
  },
  goalDetailId: {
    display: 'block',
    fontSize: '20px',
    marginBottom: '24px !important',
    color: '#1A1A1A',
    fontWeight: 500,
    textAlign: 'left',
  },
  goalDetailTitle: {
    display: 'block',
    fontSize: '20px !important',
    marginBottom: '12px !important',
    color: '#1A1A1A',
    fontWeight: '400 !important',
    textAlign: 'left',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '15px !important',
    },
  },
  goalDescription: {
    display: 'block',
    fontSize: '16px !important',
    marginBottom: '24px !important',
    color: '#666 !important',
    textAlign: 'left',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px !important',
      marginBottom: '18px !important',
    },
  },
  progressSection: {
    marginBottom: '32px',
  },
  progressInfo: {
    display: 'flex',
    gap: '26px',
    marginBottom: '8px',
  },
  progressText: {
    fontSize: '14px !important',
    color: '#8A8A8A !important',
    fontWeight: '500 !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '10.5px !important',
    },
  },
  callsTitle: {
    fontSize: '20px !important',
    marginBottom: '8px !important',
    textAlign: 'left',
    color: '#1A1A1A',
    fontWeight: "500 !important",
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '15px !important',
    },
  },
  callsContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#F5F5F5',
    borderRadius: '8px',
    padding: '16px',
  },
  callCard: {
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    padding: '16px',
    marginBottom: '16px',
    border: '1px solid #E0E0E0',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  callHeader: {
    display: 'flex',
    alignItems: 'center',
  },
  callId: {
    display: 'flex',
    fontSize: '13px',
    color: '#666',
    fontWeight: 500,
    alignItems: 'center !important',
  },
  callStatus: {
    fontSize: '13px',
    marginBottom: '8px !important',
    fontWeight: 500,
  },
  callInfo: {
    fontSize: '14px',
    color: '#1A1A1A',
    marginBottom: '8px !important',
  },
  recordingLink: {
    fontSize: '14px',
    color: '#5E35B1',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  topHeader: {
    fontSize: '16px',
    fontWeight: 500,
    color: '#1A1A1A',
    marginBottom: '24px',
  },
  optionsButton: {
    fontSize: '14px',
    color: '#604797',
  },
  goalInformation: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
  },
  pageContainer: {
    margin: '24px',
    [theme.breakpoints.down('ultraHD')]: {
      margin: '18px',
    },
  },
  card: {
    margin: '24px',
    height: '83vh',
    boxShadow: 'none !important',
    borderRadius: '12px !important',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    padding: '24px',
    [theme.breakpoints.down('ultraHD')]: {
      height: '84vh',
      margin: '18px',
      padding: '18px',
    },
    [theme.breakpoints.down('fullHD')]: {
      height: '84vh',
    },
    [theme.breakpoints.down('HD')]: {
      height: '83vh',
    },
    [theme.breakpoints.down('xxl')]: {
      height: '83vh',
    },
    [theme.breakpoints.down('xl')]: {
      height: '83vh',
    },
    [theme.breakpoints.down('lg')]: {
      height: '100%',
    },
  },
  gridItem: {
    padding: '10px',
    height: '100%',
    borderRadius: '4px',
  },
  verticalDivider: {
    marginBlock: '10px !important',
    borderLeft: '2px solid #F3ECF3',
    height: '97%',
    [theme.breakpoints.down('ultraHD')]: {
      borderLeft: '1.5px solid #F3ECF3',
    },
  },
  cardtitle: {
    fontSize: '20px',
    display: 'flex',
    fontWeight: '500 !important',
    marginBottom: '30px',
  },
  milestonetitle: {
    fontSize: '20px',
    display: 'flex',
    fontWeight: '500 !important',
    color: '#373A45',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '15px !important',
    },
  },
  milestonesubtitle: {
    fontSize: '12px',
    display: 'flex',
    fontWeight: '400 !important',
    marginBottom: '30px',
  },
  radioLabel: {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px !important',
    },
  },
  textfield: {
    fontSize: '16px',
    '& .MuiOutlinedInput-input': {
      height: '20px ',
      [theme.breakpoints.down('ultraHD')]: {
        fontSize: '12px',
        height: '15px ',
      },
    },
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px',
    },
  },
  cardsubtitle: {
    fontSize: '16',
    display: 'flex',
    fontWeight: '400 !important',
    marginBottom: '30px',
  },

  // action menu
  dropDown: {
    width: '310px !important',
    padding: '2px 10px !important',
    // border: '1px solid #e9e6ed',
    borderRadius: '8px !important',
    marginTop: '4px !important',
    backgroundColor: '#fff',
    boxShadow: '0px 0.75px 30px 0px rgba(0, 0, 0, 0.10)  !important',
    [theme.breakpoints.down('ultraHD')]: {
      width: '230px !important',
      borderRadius: '6px !important',
    },
  },
  dropDownMenuItem: {
    cursor: 'pointer',
    padding: '1 0.5 !important',
    fontWeight: '500 !important',
    color: '#585A64 !important',
    fontSize: '16px !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '12px !important',
    },
  },
  DailogTitle: {
    fontSize: '20px',
    fontWeight: '600 !important',
    color: '#373A45 !important',
    textAlign: 'left',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '15px',
    },
  },
  label: {
    fontSize: '12px',
    fontWeight: '500 !important',
    color: '#373A45 !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '10.5px',
    },
  },
  dailogTextarea: {
    borderRadius: '8px !important',
    marginTop: '12px !important',
    '& .MuiFormHelperText-root': {
      fontsize: '16px !important',
    },
    [theme.breakpoints.down('ultraHD')]: {
      borderRadius: '6px!important',
      marginTop: '9px !important',
      '& .MuiFormHelperText-root': {
        fontsize: '12px !important',
      },
    },
  },
  dailoogCancelBtn: {
    height: '36px',
    fontWeight: '500 !important',
    fontSize: '16px !important',
    boxShadow: 'none',
    borderRadius: '8px',
    color: '#604797 !important',
    '&:hover': {
      color: '#604797',
    },
    [theme.breakpoints.down('ultraHD')]: {
      height: '27px',
      fontSize: '12px !important',
      borderRadius: '6px',
    },
  },
  dailoogSubmitBtn: {
    height: '36px!important',
    fontWeight: '500 !important',
    fontSize: '16px !important',
    boxShadow: 'none',
    borderRadius: '8px !important',
    [theme.breakpoints.down('ultraHD')]: {
      height: '27px!important',
      fontSize: '12px !important',
      borderRadius: '6px!important',
    },
  },
  titleUnderLine: {
    background: 'linear-gradient(270deg, rgba(122, 55, 126, 0.00) 3.86%, rgba(122, 55, 126, 0.80) 99.07%)',
    height: '1px',
    width: '100%',
    marginTop: '11px',
    [theme.breakpoints.down('ultraHD')]: {
      height: '0.75px',
      marginTop: '8px',
    },
  },
  formContainer: {
    paddingBlock: '24px !important',
    [theme.breakpoints.down('ultraHD')]: {
      paddingBlock: '18px !important',
    },
  },
  deleteText: {
    fontSize: '21px',
    fontWeight: '500 !important',
    color: '#373A45 !important',
    [theme.breakpoints.down('ultraHD')]: {
      fontSize: '16px',
    },
  },
  
  // Mobile-specific styles
  mobileContainer: {
    padding: '16px',
    background: '#F8F9FA',
    minHeight: '100vh',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  mobileHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '24px',
    padding: '16px',
    background: '#FFFFFF',
    borderRadius: '12px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  },
  mobileHeaderTitle: {
    fontSize: '18px',
    fontWeight: '600 !important',
    color: '#333333',
  },
  mobileAddButton: {
    background: '#F0EDF6 !important',
    color: '#604797 !important',
    fontSize: '12px !important',
    padding: '8px 16px !important',
    borderRadius: '8px !important',
    boxShadow: 'none !important',
    '&:hover': {
      background: '#E8E3F3 !important',
    },
  },
  mobileProgressCard: {
    background: '#FFFFFF',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '20px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  },
  mobileGoalCard: {
    background: '#FFFFFF',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '16px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    '&.active': {
      border: '2px solid #5E35B1',
    },
    '&:not(.active)': {
      border: '1px solid #E0E0E0',
    },
  },
  mobileGoalCardHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '12px',
  },
  mobileGoalNumber: {
    fontSize: '12px',
    color: '#666666',
    marginBottom: '4px',
  },
  mobileGoalTitle: {
    fontSize: '16px',
    fontWeight: '600 !important',
    color: '#333333',
    marginBottom: '8px',
  },
  mobileGoalStatus: {
    fontSize: '12px',
    fontWeight: '500 !important',
  },
  mobileGoalDescription: {
    fontSize: '12px',
    color: '#666666',
    marginBottom: '8px',
    lineHeight: '1.4',
  },
  mobileGoalDateRange: {
    fontSize: '10px',
    color: '#999999',
    marginBottom: '12px',
  },
  mobileProgressCircle: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '16px',
  },
  mobileProgressText: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
    fontWeight: '600 !important',
  },
  mobileDetailButton: {
    fontSize: '12px !important',
    color: '#604797 !important',
    textTransform: 'none',
    padding: '4px 8px !important',
    '&:hover': {
      background: '#F0EDF6 !important',
    },
  },
  mobileEmptyState: {
    background: '#FFFFFF',
    borderRadius: '12px',
    padding: '40px 20px',
    textAlign: 'center',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  },
  mobileEmptyText: {
    fontSize: '14px',
    color: '#666666',
  },
}));
